var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.0826 13.5L13.8085 9.15656H9.26935V6.33797C9.26935 5.14969 9.90344 3.99141 11.9364 3.99141H14V0.293438C14 0.293438 12.1273 0 10.3369 0C6.59872 0 4.15528 2.08031 4.15528 5.84625V9.15656H0V13.5H4.15528V24H9.26935V13.5H13.0826Z","fill":"#717476"}));
}

Facebook.defaultProps = {"width":"14","height":"24","viewBox":"0 0 14 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
